import { render, staticRenderFns } from "./Verka_Exclamation_Mark_Pos.vue?vue&type=template&id=2673509a&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports